import classNames from 'classnames';

import BenefitsContentMedia from './BenefitsContentMedia';
import { BenefitsContentFragmentFragment } from '../../__generated__/graphql';
import RawHtml from '../../components/RawHtml';
import Section from '../../layout/Section';
import SectionTitle from '../../layout/Section/SectionTitle';
import { ContentBlock } from '../types';

import style from './benefits-content.module.css';

const BenefitsContent: ContentBlock<BenefitsContentFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.benefitscontent;

  if (!contentBlockProps) {
    return null;
  }

  const isVideo = contentBlockProps.media?.type?.toLowerCase() === 'video';

  return (
    <Section
      backgroundColor="black"
      id={contentBlockProps.sectionId}
      innerContainerClassName={style.benefitsContent}
    >
      {contentBlockProps.title && (
        <SectionTitle>
          {contentBlockProps.title}
        </SectionTitle>
      )}

      {contentBlockProps.textContent && (
        <RawHtml
          className={classNames(
            style.benefitsContentTextContent,
            {
              [style.benefitsContentTextContentWithVideo]: isVideo,
              // eslint-disable-next-line @stylistic/max-len
              [style.textContentCenter]: contentBlockProps.textContentVerticalAlignment?.[0]?.toLowerCase() === 'center',
            },
          )}
        >
          {contentBlockProps.textContent}
        </RawHtml>
      )}

      {contentBlockProps.media?.type && (
        <BenefitsContentMedia
          className={style.benefitsContentMedia}
          content={contentBlockProps.media}
        />
      )}
    </Section>
  );
};

export default BenefitsContent;
